import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", y = 28 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children, className = "" }) {
  return (
    <span className={`text-xs font-extrabold uppercase tracking-[0.25em] text-brand ${className}`}>
      {children}
    </span>
  );
}

export function PageHeader({ overline, title, subtitle }) {
  return (
    <section className="bg-navy text-white relative grain overflow-hidden">
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand/20 rounded-full blur-[120px]" />
      <div className="max-w-7xl mx-auto px-5 md:px-10 pt-28 pb-20 relative">
        {overline && <Overline>{overline}</Overline>}
        <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter mt-4 max-w-4xl leading-[1.05]">
          {title}
        </h1>
        {subtitle && <p className="text-white/60 text-lg mt-6 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
